/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BlankEnum } from './blank-enum';
import { PaymentOptionEnum } from './payment-option-enum';

/**
 * @type DeckCreateInvestmentRequestPaymentOption
 * @export
 */
export type DeckCreateInvestmentRequestPaymentOption = BlankEnum | PaymentOptionEnum;
